/* eslint-disable */

import {bus} from '@/main';
import toast from '@/services/toast';

const $ = window.jQuery = require('jquery'); 

export default {
  name: 'contest-feedback-form',
  components: {},
  props: ['quizInfo'],
  data () {
    return {
      submitted:false,
      feedback:'',
      entity_id:'',
      entity_name:'',
      entity_type:'',
      contestDetails:{}
    }
  },
  computed: {

  },
  mounted () {
    console.log(this.quizInfo, "Cjeclonf")
  let _self = this;
  $(document).ready(function (argument) {
  $(document).click(function(event) {
    //if you click on anything except the modal itself or the "open modal" link, close the modal
    if (!$(event.target).closest(".feeadback_form_inner, .contest_feedback_wrp .btn").length) {
      _self.feedbackFormCloseFun()
    }
  });
});
  },
  methods: {
    validateAddUserBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          let data = {
            entity_id:this.quizInfo.id,
            entity_name:this.quizInfo.name,
            entity_type:3,
            feedback:this.feedback,
            user:this.quizInfo.connected_to_user,
          }
          this.$store.dispatch('ivQuizFeedbackSubmittedMethod', data).then((res) => {
              toast.success(res.msg);
              this.feedback = ''
              this.$validator.reset();
              bus.$emit('contestFeedbackBus', false);
              bus.$emit('checkContestFeedbackBtnBus', false);
          }).catch((err) => {
            toast.error(err.msg);
          })
          return;
        }
      })
    },
    feedbackFormCloseFun(){
      bus.$emit('contestFeedbackBus', false);
    }
  }
}